import { IntActions, IntSel } from "@/features/internal";
import { Layout } from "antd";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Fullscreen from "react-full-screen";

import Header from "./Header";

import Sidebar from "./Sidebar";

import styles from "./styles.less";

const useSidebar = () => {
  const dispatch = useDispatch();
  const collapsed = useSelector(IntSel.sidebarCollapsed);

  return {
    collapsed,
    setCollapsed: (collapsed: boolean) => {
      dispatch(IntActions.setSidebarCollapsed(collapsed));
    }
  };
};

const AppLayout: FC = ({ children }) => {
  const dispatch = useDispatch();
  const { collapsed, setCollapsed } = useSidebar();
  const isFullScreen = useSelector(IntSel.isFullScreen);
  const { pathname } = useLocation();

  return (
    <Fullscreen enabled={isFullScreen} onChange={isFull => dispatch(IntActions.setFullScreen(isFull))}>
      <Layout>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout>
          {pathname !== "/" && <Header />}
          <Layout.Content className={styles.content}>
            <main className={styles.body}>{children}</main>
          </Layout.Content>
        </Layout>
      </Layout>
    </Fullscreen>
  );
};

export default AppLayout;
